import { Link, useLocation } from 'react-router-dom'
import { BookImage, FlexBox, Text } from '@fable/components'
import { css, cx, useTheme } from '@fable/theme'
import { Book } from '@fable/types'
import { bookRoute } from 'app/store/routes'
import { BooksCalloutPalette } from './types'

const BookGridItem = ({
  book,
  palette,
}: {
  book: Book
  palette: BooksCalloutPalette
}) => {
  const { motion, mediaQueries } = useTheme()
  const { pathname } = useLocation()
  const bookLink = {
    pathname: bookRoute(book),
    state: { prevPath: pathname },
  }

  return (
    <FlexBox
      data-testid={`book-${book.isbn}`}
      className={cx(
        css`
          height: 100%;
          ${mediaQueries.mobileL} {
            &:hover .fds--ui-book-grid-image {
              transform: translateY(-10px);
              box-shadow: 0 25px 50px rgb(0 0 0 / 10%);
            }
          }
        `,
        'fade'
      )}
      alignItems="stretch"
    >
      <Link to={bookLink}>
        <BookImage
          className={cx(
            css`
              margin-right: 24px;
              width: 130px;
              height: 196px;
              flex-shrink: 0;
              ${motion.transition(['transform', 'box-shadow'])}
              img {
                height: 100%;
                object-fit: cover;
              }
            `,
            'fds--ui-book-grid-image'
          )}
          image={book.cover_image as string}
          altTag={`${book.title} book cover`}
          size={260}
        />
      </Link>
      <FlexBox
        className={css`
          height: 100%;
        `}
        flexDirection="column"
        justifyContent="space-between"
      >
        <div>
          <Text
            className={css`
              margin: 24px 0 4px;
            `}
            tag="p"
            type="subhead"
            sizing="S"
            color={palette.title}
            text={book.title}
          />
          {book.authors.length ? (
            <Text
              type="body"
              sizing="M"
              color={palette.subtitle}
              text={book.authors[0].name}
            />
          ) : null}
        </div>
      </FlexBox>
    </FlexBox>
  )
}

export default BookGridItem
